import PortfolioInfo from "./PortfolioInfo";

export default PortfolioInfo;
